import { useFeatureFlags } from '@hooks/useFeatureFlags';
import { fetchFeatureAccess } from '@queries/featureAccess';
import { useQuery } from '@tanstack/react-query';

export const FEATURE_ACCESS_KEY = ['feature-access'] as const;

/**
 * The caller's limited-preview feature access, fetched once per session
 * (long staleTime — cohort changes are rare and a reload picks them up).
 * Defaults to `false` while loading or on error, so gated UI stays hidden
 * unless the backend positively confirms access. Skipped entirely on
 * builds where the PbqaEval flag is off (PPL).
 */
export const useFeatureAccess = () => {
  const getFeatureFlagState = useFeatureFlags();
  const flagEnabled = getFeatureFlagState('PbqaEval') ?? false;

  const { data, isLoading } = useQuery({
    queryKey: FEATURE_ACCESS_KEY,
    queryFn: fetchFeatureAccess,
    enabled: flagEnabled,
    staleTime: 15 * 60 * 1000,
    retry: false,
  });

  return {
    pbqaEval: (flagEnabled && data?.pbqa_eval) ?? false,
    pbqaReview: (flagEnabled && data?.pbqa_review) ?? false,
    isLoading: flagEnabled && isLoading,
  };
};
